var _path, _mask, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniAguaResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M25.488 15.302h-5.86c-.696 0-1.26.566-1.26 1.26v5.861c0 .695.564 1.26 1.26 1.26h5.86c.696 0 1.26-.565 1.26-1.26v-5.861c0-.694-.564-1.26-1.26-1.26z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "3n4wra8z9a",
    width: 3,
    height: 6,
    x: 28,
    y: 17,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.429 17.314h1.941v5.162h-1.941v-5.162z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3n4wra8z9a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M30.16 17.314H28.64c-.117 0-.21.095-.21.21v4.742c0 .116.093.21.21.21h1.521c.116 0 .21-.094.21-.21v-4.742c0-.115-.094-.21-.21-.21z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M10 22.913v1.805c0 .317.258.575.575.575h3.61c.316 0 .575-.258.575-.575v-1.805c0-.464.377-.84.84-.84h1.087v-4.76H15.6c-3.087 0-5.6 2.513-5.6 5.6zM12.139 27.06c-.463 0-.84.376-.84.84v2.012c0 .464.377.84.84.84.463 0 .84-.376.84-.84V27.9c0-.464-.377-.84-.84-.84zM26.382 10h-7.646c-.465 0-.84.376-.84.84 0 .464.375.84.84.84h2.983v2.711h1.679v-2.71h2.984c.463 0 .84-.377.84-.84 0-.465-.377-.84-.84-.84z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniAguaResting);
export default __webpack_public_path__ + "static/media/icon_mini_agua_resting.ed334a4fec2066a1ca34e6bee7f14c3a.svg";
export { ForwardRef as ReactComponent };